import moment from 'moment'

export function formatShort (dt) {
    if (!dt) return ''
    const m = moment(dt)
    return m.format('DD/MMM')
}
